import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError, } from 'rxjs/operators';
import { CompanyProfile } from '../types/company-profile';
import { EnvService } from '../services/env.service';
import { Subject} from 'rxjs';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class CompanyProfileService {

  private companyNameSource = new Subject<string>();
  companyName$ = this.companyNameSource.asObservable();

  dataRow : any;
  selectedCompany ="Select Company";

  constructor(private http: HttpClient,private env: EnvService) {
    this.selectedCompany = this.getSelectedCompany();

   }

      addCompany(data):Observable <any>{
        return this.http.post<any>(`${this.env.apiUrl}/companyProfile`,  data ,httpOptions)
          .pipe(catchError(this.handleError));
        
      }

      getCompanyDetails():Observable  <any> {
        let httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };
         return this.http.get <any>(`${this.env.apiUrl}/companyProfile`,httpOptions)
        .pipe(catchError(this.handleError));
           
        }

     getAll():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/companyProfile`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

     updateCompany(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/companyProfile`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    updateLogo(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/companyProfile/updateLogo`, data)
        .pipe(catchError(this.handleError));
       
    }

    updateSignature(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/companyProfile/updateSignature`, data)
        .pipe(catchError(this.handleError));
       
    }

    updateDefaultCompany(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/companyProfile/updateDefaultCompany`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteCompany(id: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/companyProfile/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    getDefaultCompanyName():Observable  <any> {
      let httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };
       return this.http.get <any>(`${this.env.apiUrl}/companyProfile/getDefaultCompany`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

    changeCompany(companyName : string){
      this.companyNameSource.next(companyName);
    }

    getSelectedCompany(){
      return localStorage.getItem('selectedCompany')
    }
  

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }

}
